export const forgotPassword = {
  fields: [
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'Enter your Email', 
      required: true,
    },
    {
      name: 'resendForgotPasswordLink',
      label: 'resendForgotPasswordLink',
      type: 'resendForgotPasswordLink',
      line1: 'Didn’t receive link?', 
      action1: null, 
      line2: 'Resend Link', 
      action2: 'resendLink'
    }
  ],
  buttons: [
    {
      label: 'Submit',
      action: 'submit',
      type: 'button',
      className: 'btn-next',
    }
  ],
};
